import React from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

const TabPannel = ({ value, handleChange, tabs, tabContents, isDisabled }) => {
  return (
    <Box sx={{ width: '100%', typography: 'body1' }} className="tabpannel">
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleChange} variant="scrollable"  orientation="horizontal">
                      {tabs.map((tab, index) => (
                          <Tab sx={{textTransform:"capitalize"}} label={tab} value={index.toString()} key={index} disabled={isDisabled} />
            ))}
          </TabList>
        </Box>
        {tabContents.map((content, index) => (
          <TabPanel value={index.toString()} key={index}>
            {content}
          </TabPanel>
        ))}
      </TabContext>
    </Box>
  );
};

export default TabPannel;
